<div class="card mb-0 center-block text-center" style="width: 700px;">
  <div class="card-body d-flex align-items-center justify-content-center" style="padding: 36px 40px">
    <form [formGroup]="userPhoneForm">
        <!-- <div class="card-body"  style="padding: 36px 40px"> -->
          <h1 class="card-title">
            Turn On Mobile Notifications
          </h1>
          <h6>
            Enable text notifications to ensure you never miss a new review!
          </h6>
          <h6 class="mt-4">
            We’ll text you an alert when we detect a new review on one of your review sites. You can disable notifications anytime in your account.
          </h6>
          <div class="phone-number-form mt-4">
            <ngx-intl-tel-input
              [preferredCountries]="preferredCountries"
              [enableAutoCountrySelect]="true"
              [searchCountryFlag]="true"
              [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
              [selectFirstCountry]="false" 
              [selectedCountryISO]="CountryISO.UnitedStates"
              [maxLength]="15" 
              [phoneValidation]="true" 
              [separateDialCode]="true"
              name="phoneNumber"
              formControlName="phoneNumber"
              >
            </ngx-intl-tel-input>
          </div>
          <div class="d-flex justify-content-center align-items-center w-100 gap-3 mt-4">
              <button
                [class.btn-outline-secondary]="!userPhoneForm.valid"
                [disabled]="!userPhoneForm.valid"
                class="btn btn-primary"
                (click)="onSaveNumber(userPhoneForm)"
              >
              Enable Texts
              </button>
              <ng-content></ng-content>
          </div>
          <p class="card-info">
            *We will never use your mobile number for solicitation purposes. Message and data rates may apply. Messaging frequency varies depending on the amount of reviews received. 
            Text HELP for help or STOP to cancel receiving messages. 
            More information can be found in <a href="https://about.plsrvw.me/terms-of-service" target="_blank">SMS Terms</a>  and <a href="https://about.plsrvw.me/privacy-policy" target="_blank">Privacy Policy</a> .
          </p>
      </form>
  </div>
</div>